import { mutatorAction } from 'satcheljs';
import getStore from '../store';

const setWasDismissedMutator: () => void = mutatorAction('setReplyNudgeWasDismissed', (): void => {
    const store = getStore();
    store.wasDismissed = true;
});

export default setWasDismissedMutator;
